interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

export function Switch({ 
  checked, 
  onChange, 
  disabled = false,
  size = 'md',
  label
}: SwitchProps) {
  const sizes = {
    sm: {
      container: 'w-8 h-4',
      ball: 'w-3 h-3',
      translate: 'translate-x-4'
    },
    md: {
      container: 'w-11 h-6',
      ball: 'w-5 h-5',
      translate: 'translate-x-5'
    },
    lg: {
      container: 'w-14 h-7',
      ball: 'w-6 h-6',
      translate: 'translate-x-7'
    }
  }

  const currentSize = sizes[size]

  return (
    <label 
      className="inline-flex items-center cursor-pointer"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={(e) => {
            e.stopPropagation()
            onChange(e.target.checked)
          }}
          disabled={disabled}
        />
        <div
          className={`
            ${currentSize.container}
            ${checked ? 'bg-gray-900' : 'bg-gray-300'}
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            rounded-full transition-colors duration-200 ease-in-out
            relative flex items-center
          `}
        >
          <div
            className={`
              ${currentSize.ball}
              ${checked ? currentSize.translate : 'translate-x-0.5'}
              bg-white rounded-full shadow-lg transform transition-transform duration-200 ease-in-out
              absolute
            `}
          />
        </div>
      </div>
      {label && (
        <span className={`ml-3 text-sm ${disabled ? 'text-gray-400' : 'text-gray-700'}`}>
          {label}
        </span>
      )}
    </label>
  )
}